import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class MaterialSensor extends BaseModel {
  populateAttributesFromStore(rootStore) {
    this.sensor = rootStore.sensorStore.getById(this.sensorName);
    this.material = rootStore.materialStore.getById(this.materialId);
  }
}

decorate(MaterialSensor, {
  sensorName: observable,
  sensor: observable,
  materialId: observable,
  material: observable,
});
